const Base64Url = require('./Base64Url')
const httpBuildQuery = require('locutus/php/url/http_build_query')
const fetch = require('node-fetch')
const call_user_func = require('locutus/php/funchand/call_user_func')
const JWTParser = require('./JWTParser')

module.exports = {
    makeLink : function (props) {
        const query = {
			redir : Base64Url.encode(props.redir),
			callback : Base64Url.encode(props.callback)
        }

		if(typeof props.type != 'undefined' && props.type == 'logout')
		{            
            delete query.callback
		}
		return props.baseUrl + "?" + httpBuildQuery(query);
    },
    communicate : function(server, token, actionFunc = null)
	{				
		return new Promise ( (resolve) => {
            fetch(server, {
				method : 'get',
				headers : {'Authorization' : 'Bearer ' + token}
			})
			.then(res => res.json())
			.then(response => {			
				resolve(actionFunc ? call_user_func(actionFunc, response) : response)
			})
			.catch(err => {
				resolve({ loggend_in :false , connected : false, token : token, error : err})
			})
        })
	},
	recv : function(props) {		
		props = {
			domains : props.domains ? props.domains : [],
			ssotok : props.ssotok ? props.ssotok : false,
			secured : props.secured ? props.secured : false,
		}

		return new Promise((resolve) => {
			if(jwt = JWTParser.parseToken(props.ssotok))
			{			
				props.domains.forEach((domain) => {
					document.cookie= "ssotok="+props.ssotok+"; expires="+jwt.payload.exp+"; path=/;domain="+domain+"; secure="+props.secured;
				})
			}
			resolve(true)
		})
	}

}